<script setup lang="ts">
import { FormRow } from '@shared/ui/form-row'
import { RadioItem } from '@shared/ui/radio'

import { useTutorApplicationStore } from '../../model/store'
import { useTeachingExperienceYears } from '../../model/additional-questions/teaching-experience-years.hooks'
import { teachingExperienceOption } from '../../config/additional-questions'

defineOptions({
  name: 'TeachingExperienceYears',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  label,
  setTeachingExperienceYears,
} = useTeachingExperienceYears()

</script>

<template>
  <FormRow
    :label="label"
    required
  >
    <RadioItem
      v-for="option in teachingExperienceOption"
      :key="option.value"
      :label="option.label"
      :mode="mode"
      :checked="tutorApplicationStore.teachingExperienceYears === option.value"
      @click="setTeachingExperienceYears(option.value)"
    />
  </FormRow>
</template>
